import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import CatalogueExplorer from '@/components/catalogue/explorer/CatalogueExplorer';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { UserGuideButton } from '@/components/guide/UserGuideButton';
import SiChevronLeft from '@/icons/SiChevronLeft';
import SiFilter from '@/icons/SiFilter';
import { ImpersonationBanner } from '@/pages/product/ImpersonationBanner';
import { productExplorerStrings } from '@/pages/product/strings';
import { useCategories } from '@/services/api/hooks/catalog';
import { RoleType } from '@/services/authentication/hooks/user';
import { useCatalogueRoutePrefix } from '@/services/catalogue/useCatalogueRoutePrefix';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { useNavigateAndValidate } from '@/services/catalogue/validation/catalogueHooks';
import { FC, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

interface CustomerCatalogueProps {}

export const CustomerCatalogue: FC<CustomerCatalogueProps> = () => {
  const [categories] = useCategories();

  const { categoryId } = useParams();

  const navigateAndValidate = useNavigateAndValidate();

  useEffect(() => {
    setSearchQuery('');
    setFilterSpecQuery('');
  }, [categoryId]);

  const [, setSearchQuery] = useState<string>('');

  const [, setFilterSpecQuery] = useState<string>('');

  const categoryBreadcrumb = useMemo(() => {
    if (!categoryId) return 'Home';

    const categoryName = categories.find(category => category.id === categoryId)!.name;

    return categoryName;
  }, [categoryId, categories]);

  const breadcrumbs: NavPage[] = [
    {
      name: 'Catalogue',
      to: ''
    },
    {
      name: categoryBreadcrumb,
      to: ''
    }
  ];

  const routePrefix = useCatalogueRoutePrefix();

  const [configuration] = useCatalogueService(state => [state.configuration]);

  const navigate = useNavigate();

  return (
    <CatalogueExplorer
      header={{
        step: 1,
        title: `Catalogue`,
        subtitle: categoryBreadcrumb,
        breadcrumbs,
        controls: (
          <div className="flex flex-col space-y-4">
            <div className="flex space-x-4">
              <ImpersonationBanner />
              {configuration.as !== RoleType.Company && (
                <Button onClick={() => navigate('filters')}>
                  <SiFilter className="text-xl" />
                  <span>{productExplorerStrings.manageFilters}</span>
                </Button>
              )}
            </div>
            <div className="flex space-x-4 justify-end">
              <UserGuideButton newRoute={`${routePrefix}/catalogue/guide`} />
              {categoryId && (
                <Button onClick={() => navigateAndValidate(`${routePrefix}/catalogue`)} variant={ButtonVariant.Mono}>
                  <SiChevronLeft className="text-xl" />
                  <span>Back to full catalogue</span>
                </Button>
              )}
              <Button
                variant={ButtonVariant.Secondary}
                onClick={() => navigateAndValidate(`${routePrefix}/standardise/selectedProducts`)}
              >
                Selected Products
              </Button>
              <Button variant={ButtonVariant.Primary} onClick={() => navigateAndValidate(`${routePrefix}/bundles`)}>
                Create Bundles
              </Button>
            </div>
          </div>
        )
      }}
      navigate={navigateAndValidate}
    />
  );
};
